import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const ManProduct = () => {
  const { category } = useParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_URL = process.env.REACT_APP_URL;

  
  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      setError(null); 
      try {
        const response = await axios.get(`${API_URL}filterProducts`, {
          params: { gender: "Man", category },
        });
        setProducts(response.data);
      } catch (err) {
        console.error("Error fetching products:", err);
        setError(err.response?.data?.error || "An error occurred.");
      } finally {
        setLoading(false);
      }
    };
  
    fetchProducts();
  }, [API_URL, category]);
  
  const filteredProducts = products
    .sort((a, b) => b.id - a.id);


  return (
    <div className="container mt-5">
      <style>
        {`
          .product-grid {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 20px;
          }

          .product-card {
            width: 35vh;
            border: 1px solid #ddd;
            border-radius: 10px;
            overflow: hidden;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            background-color: #fff;
          }

          .product-card:hover {
            transform: scale(1.05);
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
          }

          .product-image-container {
            width: 100%;
            height: 35vh;
            overflow: hidden;
          }

          .product-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .product-info {
            padding: 15px;
            text-align: center;
          }

          .product-info h3 {
            font-size: 18px;
            margin: 10px 0;
            color: #333;
          }

          .product-info p {
            font-size: 16px;
            color: #777;
          }

          .view-details-btn {
            display: inline-block;
            margin-top: 10px;
            padding: 10px 20px;
            font-size: 14px;
            color: #fff;
            background-color: #007bff;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            text-decoration: none;
            transition: background-color 0.3s ease;
          }

          .view-details-btn:hover {
            background-color: #0056b3;
          }

          @media (max-width: 768px) {
            .product-card {
              width: 100%;
            }
          }
        `}
      </style>
      <h2 className="text-center">{category}</h2>
      {loading ? (
        <p className="text-center">Loading products...</p>
      ) : error ? (
        <p className="text-center text-danger">{error}</p>
      ) : filteredProducts.length > 0 ? (
        <div className="row mt-4 mb-3">
          {filteredProducts.map((product) => (
            <div className="col-md-4 mb-4" key={product.id}>
              <ProductCard product={product} navigate={navigate} category={category} imageApi={API_URL} />
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center">No products available for this category.</p>
      )}
    </div>
  );
};

const ProductCard = ({ product, navigate, category, imageApi }) => {
  return (
    <div className="product-card">
      <div className="product-image-container card-img-container">
        <img src={imageApi + "upload/" + product.image1} alt={product.name} />

      </div>
      <div className="card-body product-info">
        <h5 className="card-title">{product.name}</h5>
        <button
          className="btn btn-primary"
          onClick={() => navigate(`/man/${category}/${product.id}`)}
        >
          View Details
        </button>
      </div>
    </div>
  );
};

export default ManProduct;
